import { NUMBER_REGEX, PIN_CODE_REGEX } from "./regex";

export const isValidPinCode = (code) => {
    if (!code) {
        return false;
    }

    return PIN_CODE_REGEX.test(code.trim())
}

export const isValidPhone = (number, length=10) => {
    if  (!number) {
        return false;
    }
    const isNumber = NUMBER_REGEX.test(number.trim());
    return isNumber && number.trim().length === length;
}